import { Box, Grid, type SelectChangeEvent, Typography } from '@mui/material'
import { useEffect, useState } from 'react'
import { sendGet } from 'hooks/use-fetch'
import { CheckBoxWithLabel } from 'Components/CheckBox'
import { type lookup, type race } from 'core/types'
import { SelectWithLabel } from 'Components/SelectWithLabel'
import { CustomLabelWithToolTip } from 'Components/CustomLabel/Index'

interface RaceListProps {
  raceList: race[]
  setRaceList: (raceList: race[]) => void
  tribalAffiliationStatus?: boolean
  tribalAffiliationID?: number | null
  tribalAffiliationName?: number | null
  setTribeStatus: (checked: boolean, tribeId: number | null) => void
}

export function RaceList (props: RaceListProps): JSX.Element {
  const [ethnicityItem, setEthnicityItem] = useState<race>()
  const [raceItems, setRaceItems] = useState<race[]>([])
  const [tribeItems, setTribeItems] = useState<lookup[]>([])
  useEffect(() => {
    const fetchData = async (): Promise<void> => {
      const { response, error } = await sendGet('/Race/GetLookup', {})
      if (error[0] === '') {
        const serverItems: race[] = response
        const raceList: race[] = []
        serverItems.forEach(r => {
          if (r.id === 4) {
            setEthnicityItem(r)
          } else {
            raceList.push(r)
          }
        })
        setRaceItems(raceList)
      }
      const { response: response2, error: error2 } = await sendGet('/TribalAffiliation/GetLookup', {})
      if (error2[0] === '') {
        setTribeItems(response2)
      }
    }
    void fetchData()
  }, [])

  function RaceCheckBox (r: race): JSX.Element {
    const changeRace = (selected: boolean): void => {
      if (selected && !props.raceList.map(rl => rl.name).includes(r.name)) {
        props.setRaceList([...props.raceList, { id: r.id, name: r.name, codePosition: 0 }])
      } else {
        props.setRaceList(props.raceList.filter(x => x.name !== r.name))
      }
    }
    const result = <CheckBoxWithLabel key={r.id} label={r.name} name={r.name} dataTestId={`raceCheckBox-${r.name}`} value={props.raceList.map(rl => rl.name).includes(r.name)} setValue={changeRace} edge={'start'} />
    return result
  }
  const changeTribalAffiliationStatus = (val: boolean): void => {
    props.setTribeStatus(val, null)
  }
  const changeTribe = (event: SelectChangeEvent<number | ''>): void => {
    const x = Number(event.target.value)
    props.setTribeStatus(props.tribalAffiliationStatus ?? false, (props.tribalAffiliationStatus ?? false) ? x : null)
  }

  return <>
    <Box display={'block'}>
      <Typography variant='subtitle1' sx={{ fontWeight: 'bold' }} gutterBottom>Ethnicity</Typography>
      {ethnicityItem != null && RaceCheckBox(ethnicityItem)}
    </Box>
    <Box display={'block'}>
      <Typography variant='subtitle1' sx={{ fontWeight: 'bold' }} gutterBottom>Race *</Typography>
      <Grid container spacing={2} display={'flex'} sx={{ marginLeft: '0', paddingTop: '15px' }}>
        {raceItems.map(r => {
          return <Grid key={r.id}>{RaceCheckBox(r)}</Grid>
        })}
      </Grid>
    </Box>
    <Box>
      <CheckBoxWithLabel
        key={'tribalStatus'}
        label={'Tribal Affiliation'}
        name={'tribalAffiliationStatus'}
        dataTestId={'tribalAffiliationStatus'}
        value={props.tribalAffiliationStatus ?? false}
        setValue={changeTribalAffiliationStatus}
        edge={'start'}
      />
      {props.tribalAffiliationStatus === true && (
        <SelectWithLabel
          name="tribalAffiliationID"
          width="100%"
          value={props.tribalAffiliationID ?? ''}
          options={tribeItems}
          onChange={changeTribe}
          FormControlProps={{ className: 'pb-0' }}
          labelContent={<CustomLabelWithToolTip
            name='childTribe'
            isdId={0}
            defaultLabelText='Tribal Affiliation'
            defaultTooltipText={'This is the tribal affiliation of the child'}
          />}
        />
      )}
    </Box>
  </>
}
